import React from 'react';
import './FAQ.css';

export default function FAQ() {
  const handleRedirect = () => {
    window.open("https://www.oldmutual.com.gh/get-help/frequently-asked-questions", "_blank");
  };

  return (
    <div className="faq-container">
      <div className="faq-card">
        <div className="faq-card-body">
          <i className="bi bi-question-circle faq-icon" />
          <h3 className="faq-title">Frequently Asked Questions</h3>
          <p className="faq-text">
            Click the button below to visit our FAQ page for answers to common questions.
          </p>
          <button className="btn btn-primary btn-lg" onClick={handleRedirect}>
            Go to FAQ Page
          </button>
        </div>
      </div>
    </div>
  );
}